import axios from 'axios';
import { functions } from '@/firebase'

export default {
    verArticulos({ state, commit }, marcaTiempo = null) {
        let devolver = {
            'ok': false
        };
        let data = new FormData();
        data.append('token', state.token);
        //data.append('tipo',1);
        if (marcaTiempo) {
            data.append('fecha', marcaTiempo);
        }
        return axios.post(state.url + 'verarticulosmaestros.php', data)
            .then(function (res) {
                let devolver = {
                    ok: false
                };
                let data = res.data;
                if (data.result === "OK") {
                    commit('setProductosNeo', data.articulos);
                    devolver.ok = true;
                } else {
                    devolver.error = data.message
                }
                return devolver;
            })
            .catch((error) => {
                devolver.error = error
            })
    },
    verComposicion({ state, commit }, idProducto, marcaTiempo = null) {

        let data = new FormData();
        console.log(idProducto)
        data.append('token', state.token);
        //data.append('articulo',idProducto)
        if (marcaTiempo) {
            data.append('fecha', marcaTiempo);
        }
        return axios.post(state.url + 'vercomposicion.php', data)
            .then(function (res) {
                console.log(res.data);
                let data = res.data;
                if (data.result === "OK") {
                    commit('setProductosNeoOpciones', data.composiciones);
                    Promise.resolve();
                } else {
                    Promise.reject("Fallo en Neo")
                }
            })
            .catch((error) => {
                commit('setProductosNeoOpciones', []);
            })
    },
    saveProductosNeo({ state }, prod) { //guarda en la bbdd productos Neo
        let negocio = rootState.app.negocioGest;
        state.productosNeo.forEach((prod, i) => {
            console.log(prod);
        })
        /*var ref = null
        if (id){
            ref = db.collection('negocios').doc(negocio).collection('productos').doc(id).set(prod,{merge:true})
        } else {
            ref = db.collection('negocios').doc(negocio).collection('productos').add((prod))
        }  */
    },
    volcarProductosNeo({ state, rootState }) {
        let negocio = rootState.app.negocioGest;
        var volcar = functions.httpsCallable('httpNeoVolcarNeoToFirestore');
        return volcar(negocio);
    },
    forzarPrecios({ state, rootState }) {
        let negocio = rootState.app.negocioGest;
        var volcar = functions.httpsCallable('httpNeoForzarPrecios');
        return volcar(negocio);
    },

}